import { render, staticRenderFns } from "./FieldWrapper.vue?vue&type=template&id=23fe5e06&scoped=true&"
import script from "./FieldWrapper.vue?vue&type=script&lang=js&"
export * from "./FieldWrapper.vue?vue&type=script&lang=js&"
import style0 from "./FieldWrapper.vue?vue&type=style&index=0&id=23fe5e06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fe5e06",
  null
  
)

export default component.exports